
import { Component, Vue } from "vue-property-decorator";
import { BRow, BCol, BCard, BCardGroup } from "bootstrap-vue";
@Component({
  components: {
    BRow,
    BCol,
    BCard,
    BCardGroup,
  },
})
export default class InPractisePPP extends Vue {}
